// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export var MessageGroupBy_Enum;
(function (MessageGroupBy_Enum) {
    MessageGroupBy_Enum["LOCATION"] = "LOCATION";
    MessageGroupBy_Enum["RULE"] = "RULE";
})(MessageGroupBy_Enum || (MessageGroupBy_Enum = {}));
export var MessageGroupBy_Enum_index;
(function (MessageGroupBy_Enum_index) {
    MessageGroupBy_Enum_index[MessageGroupBy_Enum_index["LOCATION"] = 0] = "LOCATION";
    MessageGroupBy_Enum_index[MessageGroupBy_Enum_index["RULE"] = 1] = "RULE";
})(MessageGroupBy_Enum_index || (MessageGroupBy_Enum_index = {}));
export const AutoWorkerService = {
    // ListMessages returns a list of messages that were previously processed based on the provided parameters.
    ListMessages(fn, req) {
        return fn(`/messaging/auto-worker/v1/messages?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // CountMessages counts the number of messages that were processed for the provided rules (including all associated locations).
    CountMessages(fn, req) {
        return fn(`/messaging/auto-worker/v1/messages:count?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // ForecastMessages calculates messages that would be sent for the provided rules (including all associated locations) without sending them.
    ForecastMessages(fn, req) {
        return fn(`/messaging/auto-worker/v1/messages:forecast?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // ForecastCountMessages counts messages that would be sent for the provided rules (including all associated locations) without sending them.
    ForecastCountMessages(fn, req) {
        return fn(`/messaging/auto-worker/v1/messages:forecast-count?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // ForecastRule calculates messages that would be sent for the provided rules (including all associated locations) without sending them.
    // This endpoint will handle requests spanning multiple days.
    ForecastRule(fn, req) {
        return fn(`/messaging/auto-worker/v1/forecast-rule`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // SuppressMessage suppresses a message from being sent.
    SuppressMessage(fn, req) {
        try {
            fm.validateUrlParam(req["messageId"], "messageId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/auto-worker/v1/messages/${req["messageId"]}:suppress`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // UnsuppressMessage unsuppresses a message from being sent.
    UnsuppressMessage(fn, req) {
        try {
            fm.validateUrlParam(req["messageId"], "messageId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/auto-worker/v1/messages/${req["messageId"]}:suppress?${fm.renderURLSearchParams(req, ["messageId"])}`, { method: "DELETE" });
    },
};
